<div class="funz-virtual-scroll">
  <h2 class="funz-virtual-scroll__title" *ngIf="title">{{ title }}</h2>
  <virtual-scroller #scroll [items]="funzes" [horizontal="true" [RTL]="true">
    <funz-box
      *ngFor="let funz of scroll.viewPortItems; index as i; trackBy: trackByFunzIdFn"
      [funz]="funz"
      [showHeart]="showHeart">
    </funz-box>
  </virtual-scroller>
</div>